import { inject } from "aurelia-framework";
import { bindable } from "aurelia-framework";
import { Router } from "aurelia-router";
import { EnvironmentService } from "../../../services/environmentService";
import { WebRtcAPI } from "../../../services/webrtcAPI";
import { UserMessageService } from "../../../services/userMessageService";

@inject(EnvironmentService, WebRtcAPI, UserMessageService)
export class WebrtcCustomElement {
  @bindable recorderReady;
  @bindable recordingStarted;
  @bindable recordingComplete;
  @bindable playbackStarted;
  @bindable playbackComplete;
  @bindable saveComplete;
  @bindable reportError;
  @bindable reportLogMessage;
  @bindable captureKey;
  @bindable reportTime;
  @bindable maxRecordTime;

  //@bindable  products = [];
  // @bindable blobURL;
  constructor(envService, api, userMessageService) {
    this.envService = envService;
    this.api = api;
    this.userMessageService = userMessageService;

    this.mimeType = "video/webm";
    this.fileExtension = "webm";
    this.type = "video";
    //this.defaultWidth = 700;
    //this.defaultHeight = 400;
    this.defaultWidth = 1280;
    this.defaultHeight = 720;
    this.aspectRatio = 1.777777778;
    this.fps = 30;
    this.bitsPerSecond = 8000000;
    this.bufferSize = 16384;
    this.file = null;
    this.externalCamera = false;

    this.uploadProgress = 0;

    this.recording = false;

    this.camera = "user";

    this.uploadError = false;
    // console.log("captureType...",window.location);

    this.isNoAudioTrack = false;

    // this.captureType = window.location.href.split("=")[1]
    var queryString = window.location.href.split("?")[1];
    if (queryString) {
      var query = queryString
        .split("&")
        .map((u) => {
          var v = u.split("=");
          return {
            [v[0]]: v[1],
          };
        })
        .reduce((accumulator, currentValue) => {
          return { ...accumulator, ...currentValue };
        }, {});

      if (query.captureType) {
        this.captureType = query.captureType;
      }
    }

    console.log(window.location);
    console.log("captureType-2", this.captureType);

    if (this.captureType && this.captureType.length > 4) {
      this.captureType = 1;
    }
    console.log("captureType-2", this.captureType);
    this.portrait = false;
    /*this.products = [
            {id: 0, name: 'Motherboard'},
            {id: 1, name: 'CPU'},
            {id: 2, name: 'Memory'}
        ];*/
    this.products = [];
    this.selectedProductId = null;
    this.deviceIds = [];

    this.brandedVideo = false;
    if (
      window.location.href.indexOf("capture/video/brand") > -1 ||
      window.location.href.indexOf("capture/video/expertTipVideo") > -1
    ) {
      console.log(">>>>> Branded Video <<<<<<");
      this.brandedVideo = true;
    }

    this.audioId = localStorage.getItem("magni_a_device_id");
    this.cameraId = localStorage.getItem("magni_v_device_id");
  }
  cameraChanged(cameraId) {
    console.log("Camera id switched" + cameraId);

    if (!this.recording) {
      /* if(this.camera == "user") {
                 this.camera = "environment";
             } else {
                 this.camera = "user";
             }*/
      this.camera = cameraId;

      this.stopStream();
      this.openMediaStream();
    }
  }
  attached() {
    console.log("tttttt", this.captureType, this.captureKey);
    this.recordingPlayer.onerror = function (e) {
      console.error(
        "Error from video player: (Code: " +
          e.target.error.code +
          " Message: " +
          e.target.error.message +
          ")"
      );
      this.reportError({ msg: "Unexpected error playing video" });
    }.bind(this);

    window.onunhandledrejection = function (e) {
      console.error(e.reason);
    }.bind(this);
    // this.logUserDevices();
    let count = 0;
    let cameraId = 0;
    let products = [];
    let deviceIds = [];
    this.products = [];
    if (1) {
      navigator.mediaDevices.enumerateDevices().then(
        function (devices) {
          devices.forEach(function (device) {
            console.log("=================================");
            console.log(device);
            console.log("camera kind ", device.kind);
            console.log("camera label ", device.label);
            console.log("camera id ", device.deviceId);
            console.log("=================================");
            if (device.kind == "videoinput") {
              count++;
              //let temp = {};
              let temp = { id: device.deviceId, name: device.label };
              products.push(temp);
              deviceIds.push(device.deviceId);
              /*if(!(device.label.includes("Integrated Camera") || device.label.includes("FaceTime")) )
                        {
                            cameraId = device.deviceId;
                            console.log("camera name, camera id, device id", device.label, cameraId, device.deviceId);
    
                        } else {
                            console.log('Here......');
                        }*/
            }
            // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
          });
          this.products = products;
          this.deviceIds = deviceIds;
          console.log(" Devices Ids ", JSON.stringify(deviceIds));

          this.selectedProductId = this.cameraId
            ? this.cameraId
            : this.deviceIds[0];
          console.log(
            "%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%555",
            this.cameraId ? this.cameraId : this.deviceIds[0],
            this.cameraId
          );
          this.camera = this.cameraId ? this.cameraId : this.deviceIds[0];
          /*if(count>=2)
                {
                    if (confirm('Do you want to use external camera?')) {
                        this.camera = cameraId;
                    } else {
                        this.externalCamera = false;
                        this.camera = "855bd8d52d36233cae89ba98c92f2618b505bf1c9a19ebccc04b8c5404ae5fd5";
                    }
                }*/
          // this.selectedProductId = this.deviceIds[0];
          // this.camera = this.deviceIds[0];
          //this.openMediaStream();
          // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
        }.bind(this)
      );
    } //end if

    this.audioId = localStorage.getItem("magni_a_device_id");
    this.cameraId = localStorage.getItem("magni_v_device_id");

        console.log("type capppp", this.captureType)
        if (!this.captureType || this.captureType==1 || this.captureType == 3 || this.captureType == 5) {
            setTimeout(() => {
                this.analyizeMicInput();
            }, 5000);
        }
    this.gotDevices();
  }
  
  gotDevices() {
    let count = 0;
    let cameraId = 0;
    let products = [];
    let deviceIds = [];
    this.products = [];

    navigator.mediaDevices.enumerateDevices().then(
      function (devices) {
        devices.forEach(function (device) {
          console.log("=================================");
          console.log(device);
          console.log("camera kind ", device.kind);
          console.log("camera label ", device.label);
          console.log("camera id ", device.deviceId);
          console.log("=================================");
          if (device.kind == "videoinput") {
            count++;
            //let temp = {};
            let temp = { id: device.deviceId, name: device.label };
            products.push(temp);
            deviceIds.push(device.deviceId);
            /*if(!(device.label.includes("Integrated Camera") || device.label.includes("FaceTime")) )
                    {
                        cameraId = device.deviceId;
                        console.log("camera name, camera id, device id", device.label, cameraId, device.deviceId);

                    } else {
                        console.log('Here......');
                    }*/
          }
          // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
        });
        this.products = products;
        this.deviceIds = deviceIds;
        console.log(" Devices Ids gotDevices", JSON.stringify(deviceIds));

        /*if(count>=2)
            {
                if (confirm('Do you want to use external camera?')) {
                    this.camera = cameraId;
                } else {
                    this.externalCamera = false;
                    this.camera = "855bd8d52d36233cae89ba98c92f2618b505bf1c9a19ebccc04b8c5404ae5fd5";
                }
            }*/
        this.selectedProductId = this.cameraId
          ? this.cameraId
          : this.deviceIds[0];
        console.log(
          "%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%555",
          this.cameraId ? this.cameraId : this.deviceIds[0],
          this.cameraId
        );
        this.camera = this.cameraId ? this.cameraId : this.deviceIds[0];
        //this.openMediaStream();
        // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
      }.bind(this)
    );
  }
  detached() {
    this.recordingPlayer.onerror = "";

    window.onunhandledrejection = null;

    localStorage.removeItem("magni_v_device_id");
    localStorage.removeItem("magni_a_device_id");

    if (window.localStream)
      window.localStream.getTracks().forEach((track) => {
        track.stop();
      });
  }

  display() {
    this.uploadError = false;
    this.openMediaStream();
    this.recordingPlayer.hidden = false;
    this.recordingPlayer.onended = this.playbackComplete;
    this.uploadingMessage.hidden = true;
  }

  toggleCamera() {
    if (!this.recording) {
      if (this.camera == "user") {
        this.camera = "environment";
      } else {
        this.camera = "user";
      }

      this.stopStream();
      this.openMediaStream();
    }
  }

  record() {
    this.startRecording();

    if (this.timeReportTimer) {
      clearTimeout(this.timeReportTimer);
      this.timeReportTimer = null;
    }

    this.timeReportTimer = setTimeout(this.getRecordTime.bind(this), 1000);

    this.isNoAudioTrack = false;
  }

  stop() {
    if (this.recording) {
      this.stopRecording();
    } else {
      this.recordingPlayer.pause();
      this.recordingPlayer.currentTime = 0;
      this.playbackComplete();
    }
  }

  kill() {
    try {
      this.stopStream();
    } catch (e) {}
    try {
      this.recordingPlayer.pause();
    } catch (e) {}
  }

  uploadFile(fileUpload) {
    // this.file = new File([this.fileUpload.getBlob()], fileUpload[0].name, {
    //     type: fileUpload[0].type
    // });
    this.file = fileUpload;
  }

  save(upload, video_id) {
    // this.stopStream();
    // this.recordingPlayer.pause();
    // this.recordingPlayer.hidden = true;
    // this.recordingPlayer.disabled = true;

    this.video_message = false;
    if (this.captureType == 5 || upload == true) this.video_message = true;

    this.video_email = false;
    if (this.captureType == 3 || upload == true) this.video_email = true;
    this.uploadflag = upload;
    this.uploadingMessage.hidden = false;

    this.uploadError = false;
    this.uploadProgress = 0;
    // console.log("file upload", this.blobURL);

    this.portrait = this.iOS();
    //branded video request is being sent from this call over web
    this.api.saveVideo(
      this.portrait,
      this.file,
      this.captureKey,
      this.uploadflag,
      video_id,
      this.video_email,
      this.video_message,
      this.uploadProgressNotification.bind(this),
      this.uploadCapturedVideoComplete.bind(this),
      this.uploadCapturedVideoError.bind(this),
      this.brandedVideo
    );
  }

  play() {
    console.log("Blob Size: " + this.file.size.toString());
    this.playVideo(this.file, false);
    this.playbackStarted();
  }

  uploadProgressNotification(data) {
    this.uploadProgress = Math.round((data.loaded * 100) / data.total);
    localStorage.setItem("uploadFileProgress", this.uploadProgress);
  }

  uploadCapturedVideoComplete(file_name) {
    localStorage.setItem("VideoEmailFileName", file_name.preview_file);
    console.log("save video complete", file_name);
    localStorage.setItem("VideoFileName", file_name.filename);
    this.uploadError = false;
    this.saveComplete({ filename: file_name.filename });
  }

  uploadCapturedVideoError(msg, reason) {
    this.uploadError = true;
    console.error("Error uploading video: " + JSON.stringify(reason));
    this.reportLogMessage({ msg: msg });
    if (reason) this.reportLogMessage({ msg: reason });
  }

  retryUpload() {
    this.reportLogMessage({ msg: "Retrying Upload" });
    this.save();
  }

  getRecordTime() {
    var time = new Date().valueOf() - this.recordingStartTime.valueOf();
    this.reportTime({ time: time / 1000 });
    this.timeReportTimer = setTimeout(this.getRecordTime.bind(this), 1000);
  }

  openMediaStream() {
    this.stream = null;

    var mediaConstraints = { video: true, audio: true };

    mediaConstraints = this.setVideoConstraints(mediaConstraints);
    mediaConstraints = this.setAudioConstraints(mediaConstraints);
    try {
      this.logUserDevices();
      this.logAvailableConstraints();
    } catch (ex) {
      this.reportLogMessage({
        msg:
          "Error logging user device data: " + ex.toString() + "\n" + ex.stack,
      });
    }
    console.log("Media Constraints", JSON.stringify(mediaConstraints));
    navigator.mediaDevices
      .getUserMedia(mediaConstraints)
      .then(
        function (stream) {
          console.log("Media Constraints", JSON.stringify(mediaConstraints));
          this.stream = stream;

          try {
            this.logAppliedConstraints();
            this.logTrackSettings();
          } catch (ex) {
            this.reportLogMessage({
              msg:
                "Error logging user device data: " +
                ex.toString() +
                "\n" +
                ex.stack,
            });
          }

          this.addStreamStopListener(
            stream,
            function () {
              //console.log("stream ended");
            }.bind(this)
          );

          this.playVideo(stream, true);

          this.recorderReady();
          console.log("Calling gotDevices in OpnenMediaStream");
          if (!this.products[0].name) {
            console.log("Getting video input devices ...");
            console.log(JSON.stringify(this.products));
            console.log("Product Name: ", this.products[0].name);
            this.gotDevices();
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.error(error);
          if (error) {
            if (error.name) {
              switch (error.name) {
                case "NotAllowedError":
                case "PermissionDeniedError":
                case "PermissionDismissedError":
                  this.reportError({
                    msg: error.name + ": " + error.message,
                    permissionDenied: true,
                  });
                  break;
                case "ConstraintNotSatisfiedError":
                  this.reportError({
                    msg:
                      error.name +
                      ": " +
                      error.message +
                      " - " +
                      error.constraintName,
                  });
                  break;
                case "NotReadableError":
                  alert(
                    "Camera or microphone is in use by another application"
                  );
                  this.reportError({
                    msg:
                      error.name +
                      ": " +
                      error.message +
                      " - " +
                      error.constraintName,
                  });
                  break;
                default:
                  console.log("<<<<<<<", error);
                  this.reportError({ msg: error.name + ": " + error.message });
              }
            } else {
              this.reportError({ msg: error.toString() });
            }
          }
        }.bind(this)
      );
  }

  startRecording() {
    this.playVideo(this.stream, true);

    var options = {
      type: this.type,
      //leftChannel: false,
      mimeType: this.mimeType,
      disableLogs: false,
      getNativeBlob: true, // enable it for longer recordings
      video: this.recordingPlayer,
      bufferSize: this.bufferSize,
      // timeSlice: 1000 crashing on chrome 3/19/24 thats why i disbled
    };

    if (this.envService.isChrome()) {
      options.videoBitsPerSecond = this.bitsPerSecond;
      console.log("setting video bits per second");
    }

    if (this.recordRTC) {
      this.recordRTC.clearRecordedData();
    }

    this.recordRTC = RecordRTC(this.stream, options);

    this.recordRTC.setRecordingDuration(
      this.maxRecordTime * 1000,
      this.recordingStopped.bind(this)
    );
    this.recordingStartTime = new Date();
    this.recordRTC.startRecording();

    this.recording = true;

    // var ua = navigator.userAgent.toLowerCase();

    //     console.log("window size", window.innerHeight, window.innerWidth);
    // if (ua.indexOf("ipad") != -1 || ua.indexOf("iphone") != -1 || ua.indexOf("ipod") != -1) {
    //         console.log("portait iphone true");
    //         this.portrait = true;

    //     // if(window.innerHeight < window.innerWidth) {
    //     //     this.portrait = false;
    //     // }
    //  }
    // console.log("portrait", this.portrait);

    // localStorage.setItem("portrait",this.portrait);
    // this.portrait = this.iOS();

    this.recordingStarted();
  }

  stopRecording() {
    this.recordRTC.stopRecording(this.recordingStopped.bind(this));
  }

  recordingStopped(url) {
    // var audioCtx = new AudioContext();
    // var analyser = audioCtx.createAnalyser();
    this.recording = false;
    var fileName =
      "testimonial_" +
      new Date().toISOString().replace(/:|\./g, "-") +
      "." +
      this.fileExtension;

    this.file = new File([this.recordRTC.getBlob()], fileName, {
      type: this.mimeType,
    });

    this.hasVideoGotAudio(URL.createObjectURL(this.file));

    // var audiobits = this.stream.getAudioTracks();
    // var audiotrack = this.stream;

    // if (audiobits.length > 0) {
    //     console.log("audio bits",audiobits[0],"**",audiotrack,"***",audiobits.length );
    //   }
    //   else {
    //       alert("no audio");
    //   }
    // console.log("audio bits", this.audioBitsPerSecond);
    this.playVideo(this.stream, true);
    if (this.timeReportTimer) {
      clearTimeout(this.timeReportTimer);
      this.timeReportTimer = null;
    }

    console.log("Blob Size: " + this.file.size.toString());
    this.recordingComplete();
  }

  stopStream() {
    if (this.stream) {
      this.stopStreamTracks(this.stream);
      if (this.stream.stop) {
        this.stream.stop();
      }
      this.stream = null;
    }

    if (this.stream instanceof Array) {
      this.stream.forEach(function (str) {
        this.stopStreamTracks(str);
        if (str.stop) str.stop();
      });
      this.stream = null;
    }
  }

  stopStreamTracks(stream) {
    if (this.stream.getAudioTracks) {
      this.stream.getAudioTracks().forEach(function (trk) {
        if (trk.stop) trk.stop();
      });
    }

    if (this.stream.getVideoTracks) {
      this.stream.getVideoTracks().forEach(function (trk) {
        if (trk.stop) trk.stop();
      });
    }
  }

  setVideoConstraints(mediaConstraints) {
    console.log("this.camera ", this.camera);

    if (this.envService.isMobile() && this.envService.isChrome()) {
      mediaConstraints.video = {
        frameRate: { ideal: this.fps },
        width: { max: this.defaultWidth },
        height: { max: this.defaultHeight },
        aspectRatio: this.aspectRatio,
      };

      if (this.camera) {
        mediaConstraints.video.deviceId = { exact: this.camera };
      }

      if (!this.camera) mediaConstraints.video.facingMode = { ideal: "user" };
    } else if(this.camera) {
        console.log("Camera id found");
        mediaConstraints.video = {
          frameRate: { ideal: this.fps },
          width: { ideal: this.defaultWidth },
          height: { ideal: this.defaultHeight },
          aspectRatio: this.aspectRatio,
          deviceId: { exact: this.camera },
        };
    } else {
        console.log("Camera id not found using user camera");
        mediaConstraints.video = {
          frameRate: { ideal: this.fps },
          width: { ideal: this.defaultWidth },
          height: { ideal: this.defaultHeight },
          aspectRatio: this.aspectRatio,
          facingMode: { ideal: "user" },
        };
        //this.gotDevices();
    }
    

    return mediaConstraints;
  }

  setAudioConstraints(mediaConstraints) {
    const constraint = this.audioId ? { exact: this.audioId } : true;
    mediaConstraints.audio = constraint;
    //{
    //facingMode: "environment",
    //mediaSource: "speakerphone"
    //echoCancellation: false
    //mozAutoGainControl: true
    //mozNoiseSuppression: false
    //googAutoGainControl: false,
    //googNoiseSuppression: false
    //};
    return mediaConstraints;
  }

  modifyGain(stream, gainValue) {
    var context = new window.AudioContext();
    var microphone = context.createMediaStreamSource(stream);
    var gainFilter = context.createGain();
    var destination = context.createMediaStreamDestination();
    var outputStream = destination.stream;
    microphone.connect(gainFilter);
    gainFilter.connect(destination);
    gainFilter.gain.value = gainValue;
    var originalTrack = stream.getAudioTracks()[0];
    stream.removeTrack(originalTrack);
    var filteredTrack = outputStream.getAudioTracks()[0];
    stream.addTrack(filteredTrack);

    return stream;
  }

  playVideo(obj, mute) {
    if (obj instanceof MediaStream) {
      this.recordingPlayer.src = null;
      this.recordingPlayer.srcObject = obj;
    } else {
      this.recordingPlayer.srcObject = null;
      this.recordingPlayer.src = URL.createObjectURL(obj);
    }

    this.recordingPlayer.muted = mute;
    this.recordingPlayer.load();

    if (this.envService.isAndroid()) {
      this.recordingPlayer.addEventListener(
        "loadedmetadata",
        function () {
          setTimeout(
            function () {
              this.recordingPlayer.play();
            }.bind(this),
            2000
          );
        }.bind(this),
        false
      );
    }

    this.recordingPlayer.play();
  }

  addStreamStopListener(stream, callback) {
    var streamEndedEvent = "ended";

    if ("oninactive" in stream) {
      streamEndedEvent = "inactive";
    }

    stream.addEventListener(
      streamEndedEvent,
      function () {
        callback();
        callback = function () {};
      },
      false
    );

    stream.getAudioTracks().forEach(function (track) {
      track.addEventListener(
        streamEndedEvent,
        function () {
          callback();
          callback = function () {};
        },
        false
      );
    });

    stream.getVideoTracks().forEach(function (track) {
      track.addEventListener(
        streamEndedEvent,
        function () {
          callback();
          callback = function () {};
        },
        false
      );
    });
  }

  logUserDevices() {
    var data = [];
    navigator.mediaDevices.enumerateDevices().then(
      function (devices) {
        devices.forEach(function (device) {
          data.push(
            device.kind + ":*** " + device.label + " id** = " + device.deviceId
          );
        });
        console.log("camera", JSON.stringify(data));
        this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
      }.bind(this)
    );
  }

  logAvailableConstraints() {
    var data = [];
    let supportedConstraints = navigator.mediaDevices.getSupportedConstraints();

    for (let constraint in supportedConstraints) {
      if (supportedConstraints.hasOwnProperty(constraint)) {
        data.push(constraint);
      }
    }

    this.reportLogMessage({
      msg: "AvailableConstraints: " + JSON.stringify(data),
    });
  }

  logAppliedConstraints() {
    var trackdata = [];
    this.stream.getAudioTracks().forEach(function (track) {
      if (track.getConstraints) {
        var data = [];
        let constraints = track.getConstraints();
        for (let constraint in constraints) {
          if (constraints.hasOwnProperty(constraint)) {
            data.push(
              constraint + ": " + JSON.stringify(constraints[constraint])
            );
          }
        }
        trackdata.push(data);
      }
    });

    this.reportLogMessage({
      msg: "AudioTrackAppliedConstraints: " + JSON.stringify(trackdata),
    });

    trackdata = [];
    this.stream.getVideoTracks().forEach(function (track) {
      if (track.getConstraints) {
        var data = [];
        let constraints = track.getConstraints();
        for (let constraint in constraints) {
          if (constraints.hasOwnProperty(constraint)) {
            data.push(
              constraint + ": " + JSON.stringify(constraints[constraint])
            );
          }
        }
        trackdata.push(data);
      }
    });
    this.reportLogMessage({
      msg: "VideoTrackAppliedConstraints: " + JSON.stringify(trackdata),
    });
  }

  logTrackSettings() {
    var trackdata = [];
    this.stream.getAudioTracks().forEach(function (track) {
      if (track.getSettings) {
        var data = [];
        let constraints = track.getSettings();
        for (let constraint in constraints) {
          if (constraints.hasOwnProperty(constraint)) {
            data.push(
              constraint + ": " + JSON.stringify(constraints[constraint])
            );
          }
        }
        trackdata.push(data);
      }
    });

    this.reportLogMessage({
      msg: "AudioTrackSettings: " + JSON.stringify(trackdata),
    });

    trackdata = [];
    this.stream.getVideoTracks().forEach(function (track) {
      if (track.getSettings) {
        var data = [];
        let constraints = track.getSettings();
        for (let constraint in constraints) {
          if (constraints.hasOwnProperty(constraint)) {
            data.push(
              constraint + ": " + JSON.stringify(constraints[constraint])
            );
          }
        }
        trackdata.push(data);
      }
    });
    this.reportLogMessage({
      msg: "VideoTrackSettings: " + JSON.stringify(trackdata),
    });
  }

  iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  hasAudio(video) {
    if (video.hasOwnProperty("mozHasAudio") && video.mozHasAudio) return true;
    else if (video.webkitAudioDecodedByteCount) return true;
    return false;
  }

  showMessage() {
    this.userMessageService.setUserWarning(
      "web",
      "<span>* Warning this video has NO AUDIO track.*</span><br/><br/><p style='margin-right:55px'>Please record video with audio track. After recoding, play it back to make sure you can hear and see yourself.<p style='text-align:center;margin-right:55px'>OR</p><p style='margin-right:55px'>If you do not want audio in this video then proceed with the video.</p>"
    );
  }

  hasVideoGotAudio(src) {
    const video = document.createElement("video");
    video.muted = true;

    video.crossOrigin = "anonymous";
    video.preload = "auto";

    if (!this.isNoAudioTrack) {
      this.showMessage();
    }

    // old code working perfect on chrome but not on firefox

    // return new Promise((resolve, reject) => {
    //   video.addEventListener("error", reject);

    //   video.addEventListener(
    //     "canplay",
    //     () => {
    //       video.currentTime = 0.99;
    //     },
    //     { once: true } // Important because 'canplay' can be fired hundreds of times.
    //   );

    //   video.addEventListener(
    //     "seeked",
    //     () => {
    //       if (!this.hasAudio(video)) {
    //         this.showMessage();
    //         // this.updateNoAudioStatus(true)
    //         this.isNoAudioTrack = true;
    //         resolve(this.hasAudio(video));
    //       }
    //     },
    //     {
    //       once: true,
    //     }
    //   );

    // });
  }

  colorPids(vol) {
    const allPids = [...document.querySelectorAll(".pid")];
    const numberOfPidsToColor = Math.round(vol / 10);
    const pidsToColor = allPids.slice(0, numberOfPidsToColor);
    for (const pid of allPids) {
      pid.style.backgroundColor = "#e6e7e8";
    }
    for (const pid of pidsToColor) {
      // console.log(pid[i]);
      pid.style.backgroundColor = "#69ce2b";
    }
  }
  
  audioChanged(audioId) {
        console.log("audio id switched" + audioId);
    
        this.audio = audioId;
  }

  analyizeMicInput() {
    const self = this; // Capture the value of 'this'

    if (this.uploadOnly) return;

    navigator.mediaDevices
      .getUserMedia({
        audio: true,
        video: false,
      })
      .then((stream) => {
        window.localStream = stream;
        const audioContext = new AudioContext();
        const analyser = audioContext.createAnalyser();
        const microphone = audioContext.createMediaStreamSource(stream);
        const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);
        // this.colorPids(90);
        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;
        microphone.connect(analyser);
        analyser.connect(scriptProcessor);
        scriptProcessor.connect(audioContext.destination);
        scriptProcessor.onaudioprocess = () => {
          const array = new Uint8Array(analyser.frequencyBinCount);
          analyser.getByteFrequencyData(array);
          const arraySum = array.reduce((a, value) => a + value, 0);
          const average = arraySum / array.length;

          if (average) {
            self.isNoAudioTrack = true;
          }

          if (document.getElementById("progress"))
            document.getElementById("progress").style.width =
              average > 100 ? 100 : average + "%";
          else {
            scriptProcessor.disconnect();
          }
          // console.log(average);
          // console.log(Math.round(average));
          // console.log(document.getElementsByClassName('pid')[4].tagName)
          // const allPids1 = document.getElementsByClassName("pid");
          // const numberOfPidsToColor =
          // Math.round(average / 20) > 20 ? 20 : Math.round(average / 20);
          // const pidsToColor = allPids.slice(0, numberOfPidsToColor);
          // console.log(numberOfPidsToColor);
          // for (let x = 0; x < 20; x++) {
          //   if (x < numberOfPidsToColor)
          //   allPids1[x].style.backgroundColor = "#69ce2b";
          //   // else
          //   // allPids1[x].style.backgroundColor = "#e6e7e8";
          // }
        };
      })
      .catch(function (err) {
        /* handle the error */
        console.error(err);
      });
  }

  closeTip() {
    $(".main-message").hide();
    $(".recordTimeBottom").css({ marginBottom: "89px" });
  }
}



